<template>
  <div>
    <div class="content-box-tab">
      <el-tabs
        v-model="activeName"
        @tab-click="
          handleTabClick(activeName === 'newTab' ? 'oldTabForm' : 'newTabForm')
        "
        class="form-tabs"
      >
        <el-tab-pane name="newTab">
          <span slot="label">创建新订单</span>
          <el-form
            ref="newTabForm"
            :model="orderForm"
            :rules="rules"
            class="demo-ruleForm"
            key="newTab"
            label-position="left"
            label-width="125px"
            :hide-required-asterisk="true"
          >
            <el-form-item label="订单名称" prop="orderName">
              <el-input placeholder="请输入订单名称" v-model="orderForm.orderName" maxlength="45" show-word-limit v-noEmoji clearable />
            </el-form-item>
            <el-form-item label="广告主" prop="partnerId" v-if="isShowParent">
              <el-select v-model="orderForm.partnerId" clearable filterable placeholder="请选择广告主" @change="partnerChange">
                <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择购买方式" prop="buyType">
              <el-radio-group v-model="orderForm.buyType" style="margin-right: 20px">
                <el-radio-button plain :label="0">
                  合约排期
                  <el-tooltip content="合约模式,保价保量" placement="bottom" effect="light">
                    <span class="el-icon-question"></span>
                  </el-tooltip>
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="售卖方式">
              <el-radio-group v-model="orderForm.sellingType">
                <el-radio-button v-for="(item, index) in sellOptions" :key="'s' + index" :label="item.value">{{ item.label }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
<!--            <el-form-item v-show="orderForm.sellingType === 1" label="下单总量" prop="totalContract" class="flex-form-item">-->
<!--              <el-radio-group v-model="orderForm.totalContractType" @change="totalContractTypeChange">-->
<!--                <el-radio-button :label="1">排期汇总</el-radio-button>-->
<!--                <el-radio-button :label="0">自定义</el-radio-button>-->
<!--              </el-radio-group>-->
<!--              <el-input v-if="orderForm.totalContractType === 0" placeholder="请输入下单总量" v-model.trim="orderForm.totalContract" clearable>-->
<!--                <template slot="append">-->
<!--                  <el-select v-model="contractUnit" class="input-select-append">-->
<!--                    <el-option value="CPM" label="CPM">CPM</el-option>-->
<!--                    <el-option value="PV" label="PV">PV</el-option>-->
<!--                  </el-select>-->
<!--                </template>-->
<!--              </el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="投放时间" prop="contractBeginDate" v-if="orderForm.buyType === 0">
              <el-date-picker
                v-model="contractTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="handleContractTime"
                @blur="testDate"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                自动流量分配
                <el-tooltip class="item" effect="light" placement="top-start">
                  <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                  <div slot="content">选择"是"，则此订单会推送到自动流量分配列表，推送规则为"缺量时推送"</div>
                </el-tooltip>
              </div>
              <el-radio-group v-model="orderForm.pushAuto">
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="0">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="客户品牌" prop="customerBrands">
              <MultiAutoComplete
                placeholder="请输入品牌"
                query-api="getSuggestBrands"
                v-model="orderForm.customerBrands"
              />
            </el-form-item>
            <el-form-item label="客户产品" prop="customerProducts">
              <MultiAutoComplete
                placeholder="请输入产品"
                query-api="getSuggestProducts"
                v-model="orderForm.customerProducts"
              />
            </el-form-item>
            <el-form-item label="订单标签" prop="orderTag">
              <CommonSelectPannel
                :leftData="tagList"
                v-model="orderForm.orderTag"
                :selectPanelColumns="['分类', '标签']"
                selectPlaceholder="请输入关键词"
              ></CommonSelectPannel>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                业务员
                <span style="color:rgba(0, 0, 0, 0.65)">(选填)</span>
              </span>
              <el-select v-model="orderForm.adSalesmanIdList" multiple placeholder="请选择业务员" :no-data-text="noSaleman">
                <el-option
                  v-for="item in salesmanList"
                  :key="item.agentAccountId"
                  :value="item.agentAccountId"
                  :label="item.agentAccountName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                备注
                <span style="color:rgba(0, 0, 0, 0.65)">(选填)</span>
              </span>
              <el-input type="textarea" v-model="orderForm.description" clearable></el-input>
            </el-form-item>
            <el-form-item label="投放高质量设备">
              <el-switch v-model="orderForm.ipFilter" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item>
              <template #label>
                IES服务
                <el-tooltip class="item" effect="light" placement="top-start">
                  <i class="el-icon-cc-info-circle" style="font-size: 14px"></i>
                  <div slot="content">IES开启，计划审核完成后会自动替换IES宏参，并自动获取秒针的监测数据与自有监测数据对比、自动发起预警；
                    关闭后则无法获取秒针监测数据、无法发起自动预警；</div>
                </el-tooltip>
              </template>
              <el-switch v-model="orderForm.iesSwitch" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane name="oldTab">
          <span slot="label">选择已有订单</span>
          <el-form
            ref="oldTabForm"
            :model="orderForm"
            :rules="rules"
            class="demo-ruleForm"
            key="oldTab"
            label-width="117px"
            label-position="left"
            :hide-required-asterisk="true"
          >
            <el-form-item label="选择已有订单" prop="orderName">
              <CommonLazySelect
                v-model="orderForm.orderId"
                :filter="orderFilter"
                :primaryKey="primaryKey"
                :optionsMap="optionsMap"
                serviceName="getOrderList"
              ></CommonLazySelect>
            </el-form-item>
            <div class="cc-demo-ruleForm-info" v-if="orderForm.orderId">
              <template v-if="isShowParent">
                <el-form-item label="广告主">
                  <span v-if="orderForm.orderId">
                    {{
                    orderForm.partnerName
                    }}
                  </span>
                </el-form-item>
              </template>
              <el-form-item label="购买方式">
                合约排期
                <span style="color:#7c7c7c;font-size:13px;padding-left:15px">预定未来1至28天的目标人群,广告曝光单价由投放地域决定,单次投放50000元起</span>
              </el-form-item>
              <el-form-item label="售卖方式">{{translateSellTypeText[orderForm.sellingType]}}</el-form-item>
              <el-form-item label="下单总量">{{ orderForm.totalContract }} pv</el-form-item>
              <el-form-item label="投放时间">
                <template v-if="orderForm.contractBeginDate">
                  {{
                  $moment(orderForm.contractBeginDate).format('YYYY-MM-DD')
                  }}
                  -
                  {{ $moment(orderForm.contractEndDate).format('YYYY-MM-DD') }}
                </template>
                <template v-else>-</template>
              </el-form-item>
              <el-form-item label="客户品牌">
                {{ orderForm.customerBrands.join('、') }}
              </el-form-item>
              <el-form-item label="客户产品">
                {{ orderForm.customerProducts.join('、') }}
              </el-form-item>
              <el-form-item label="订单标签">
                <template v-if="orderForm.orderTag && orderForm.orderTag.length > 0">
                  <div v-for="(item, index) in tagsMapList" :key="'t' + index">
                    <el-row>
                      <el-col :span="4">{{ item.label }}&nbsp;</el-col>
                      <el-col :span="20">
                        <span v-if="item.children">{{ item.children.join(',') }}</span>
                      </el-col>
                    </el-row>
                  </div>
                </template>
                <template v-else>-</template>
              </el-form-item>
              <el-form-item label="业务员">
                <span
                  v-if="
                    orderForm.adSalesmanList &&
                      orderForm.adSalesmanList.length !== 0
                  "
                >
                  <span v-for="(item, index) in orderForm.adSalesmanList" :key="index">
                    <span>{{ item.salesmanName }}</span>
                    <span v-if="index !== orderForm.adSalesmanList.length - 1">{{ ',' }}</span>
                  </span>
                </span>
                <span v-else>-</span>
              </el-form-item>
              <el-form-item label="备注">
                <span v-if="orderForm.description">
                  {{
                  orderForm.description
                  }}
                </span>
                <span v-else>-</span>
              </el-form-item>
              <el-form-item label="高质量设备">
                <span :style="{ color: orderForm.ipFilter === 1 ? '#19bf44' : '#666' }">{{ ['关闭', '开启'][orderForm.ipFilter || 0] }}</span>
              </el-form-item>
              <el-form-item label="IES服务">
                <span :style="{ color: orderForm.iesSwitch === 1 ? '#19bf44' : '#666' }">{{ ['关闭', '开启'][orderForm.iesSwitch || 0] }}</span>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <ContentBox>
      <el-button plain @click="handleCancel">取消</el-button>
      <template v-if="activeName === 'newTab'">
        <el-button :disabled="nextStepDisable" :loading="saveBtnLoading" plain @click="onSubmit('newTabForm', 'save')">保存订单</el-button>
      </template>
      <el-button
        v-if="activeName === 'newTab'"
        type="primary"
        :disabled="nextStepDisable"
        :loading="saveBtnLoading"
        @click="onSubmit('newTabForm', 'cSave')"
      >保存并创建计划</el-button>
      <el-button v-else type="primary" :disabled="nextStepBtn" @click="nextStep">下一步</el-button>
      <el-button v-if="activeName === 'newTab'" type="primary" :disabled="nextStepDisable" :loading="saveBtnLoading" @click="onSubmit('newTabForm', 'batch')">保存并批量建单</el-button>
    </ContentBox>
  </div>
</template>
<script>
import CommonLazySelect from '@/components/common/CommonLazySelect'
import CommonSelectPannel from '@/components/scheduleDirection/CommonSelectPannel'
import MultiAutoComplete from '@/components/MultiAutoComplete.vue'
export default {
  components: {
    CommonLazySelect,
    CommonSelectPannel,
    MultiAutoComplete
  },
  props: ['isShowParent', 'createType', 'partnerId'],
  data() {
    var totalCheck = (rule, val, callback) => {
      if (this.orderForm.sellingType === 1) {
        if (this.orderForm.totalContractType === 1) {
          return callback()
        }
        if (!val) {
          callback(new Error('请输入正确的下单总量'))
        } else {
          if (!Number.isInteger(val * 1) || val * 1 < 0) {
            callback(new Error('请输入正整数'))
          } else {
            if (val > 2000000000) {
              callback(new Error('下单总量不能超过2,000,000,000,请重新输入'))
            } else {
              callback()
            }
          }
        }
      } else {
        callback()
      }
    }
    var orderTagCheck = (rule, val, callback) => {
      const checkInfo = this.handleCheckRequiredTag()
      if (!checkInfo.status) {
        return callback(new Error(checkInfo.message))
      }
      if (this.handleOrderTag(val).length > 50) {
        return callback(new Error('最多只能选择50个标签'))
      }
      const errorInfo = this.validateTagRule()
      if (errorInfo) {
        return callback(new Error(errorInfo))
      }
      callback()
    }
    var customerBrandsCheck = (rule, val, callback) => {
      if (!val || val.length === 0) {
        callback(new Error('客户品牌必填'))
      } else {
        callback()
      }
    }
    var customerProductsCheck = (rule, val, callback) => {
      if (!val || val.length === 0) {
        callback(new Error('客户产品必填'))
      } else {
        callback()
      }
    }
    return {
      options: [],
      contractUnit: 'CPM',
      activeName: this.createType,
      oldSpaceTable: [],
      orderFilter: {
        orderName: '',
        useOrderFlag: 0
      },
      primaryKey: {
        orderId: ''
      },
      optionsMap: {
        key: 'orderId',
        label: 'orderName'
      },
      tagList: [],
      tagsMapList: [],
      orderForm: this.genOrderForm(),
      rules: {
        orderName: [
          {
            required: true,
            message: '请输入订单名称',
            trigger: 'blur'
          }
        ],
        partnerId: [
          {
            required: true,
            message: '请选择广告主',
            trigger: 'change'
          }
        ],
        contractBeginDate: [
          {
            required: true,
            message: '请输入投放时间',
            trigger: 'change'
          }
        ],
        buyMethod: [
          {
            required: true,
            message: '选择购买方式',
            trigger: 'change'
          }
        ],
        totalContract: [{ validator: totalCheck, trigger: 'blur' }],
        orderTag: [{ type: 'array', validator: orderTagCheck, trigger: 'change' }],
        customerBrands: [{ type: 'array', validator: customerBrandsCheck, trigger: 'change' }],
        customerProducts: [{ type: 'array', validator: customerProductsCheck, trigger: 'change' }]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      contractTime: [],
      salesmanList: [],
      sellingTypeText: '',
      saveBtnLoading: false,
      sellOptions: []
    }
  },
  watch: {
    'orderForm.orderId'(newValue, oldValue) {
      if (newValue) {
        this.getOrderInfo(newValue)
      }
    }
  },
  computed: {
    // 保存并创建计划禁用
    nextStepDisable() {
      let form = {
        orderId: this.orderForm.orderId,
        orderName: this.orderForm.orderName,
        partnerId: this.orderForm.partnerId,
        buyType: this.orderForm.buyType,
        contractBeginDate: this.orderForm.contractBeginDate,
        contractEndDate: this.orderForm.contractEndDate,
        sellingType: this.orderForm.sellingType,
        orderTag: this.orderForm.orderTag
      }
      if (form.sellingType === 3) {
        form.totalContract = 0
      }
      if (this.activeName === 'newTab') {
        delete form.orderId
        const disable = !Object.keys(form).every((item) => {
          return form[item] !== '' && form[item] !== undefined && form[item] !== undefined
        })
        return disable
      } else {
        const disable = !Object.values(form).every(
          (item) => item !== '' && item !== undefined
        )
        return disable
      }
    },
    // 下一步禁用
    nextStepBtn() {
      let disable
      if (this.orderForm.orderId) {
        disable = false
      } else {
        disable = true
      }
      return disable
    },
    translateSellTypeText() {
      const res = this.sellOptions.reduce((result, item) => {
        result[item.value] = item.label
        return result
      }, {})
      return res
    },
    noSaleman() {
      return this.orderForm.partnerId ? '无匹配数据' : '请先选择广告主'
    }
  },
  methods: {
    genOrderForm() {
      return {
        orderId: undefined,
        orderNo: '',
        orderName: '',
        partnerId: this.isShowParent ? undefined : this.partnerId,
        dayBudget: undefined,
        buyType: 0,
        contractBeginDate: '',
        contractEndDate: '',
        totalContractType: 1,
        totalContract: undefined,
        sellingType: 1,
        adSalesmanIdList: [],
        description: '',
        ipFilter: 0,
        iesSwitch: 0,
        orderTag: [],
        pushAuto: 0,
        customerBrands: [], // 客户品牌
        customerProducts: [] // 客户产品
      }
    },
    // 切换tabs
    handleTabClick(formName) {
      this.orderForm = this.genOrderForm()
      this.contractTime = ''
      this.orderOptions = []
      this.$refs[formName].resetFields()
      if (this.activeName === 'newTab') {
        this.$refs[formName].resetFields()
      } else {
        this.$refs['oldTabForm'].resetFields()
      }
    },
    // 广告主选择变化
    partnerChange(val) {
      if (val !== '' && val !== undefined) {
        this.initSales(val)
      }
    },
    handleContractTime(val) {
      if (val) {
        this.orderForm.contractBeginDate = this.$moment(val[0]).format('YYYY-MM-DD')
        this.orderForm.contractEndDate = this.$moment(val[1]).format('YYYY-MM-DD')
      } else {
        this.orderForm.contractBeginDate = ''
        this.orderForm.contractEndDate = ''
      }
    },
    handleCancel() {
      if (this.activeName === 'newTab') {
        const newForm = this.handleForm(JSON.parse(JSON.stringify(this.orderForm)))
        const isChange = this.$consts.difference(this.oldForm, newForm)
        if (Object.keys(isChange).length === 0) {
          this.$emit('go-back')
        } else {
          this.handleShowCancelConfirm()
        }
      } else {
        if (this.orderForm.orderId) {
          this.handleShowCancelConfirm()
        } else {
          this.$emit('go-back')
        }
      }
    },
    handleShowCancelConfirm() {
      this.$confirm('页面内容未保存,确定要离开吗？', '提示', {
        confirmButtonText: '离开页面',
        cancelButtonText: '留在页面',
        center: true,
        type: 'warning'
      })
        .then(() => {
          this.$emit('go-back')
        })
        .catch(() => {})
    },
    // 判断选择时间是否小于当前时间
    testDate() {
      let _now = new Date()
      if (this.contractTime[0] < _now) {
        this.contractTime[0] = _now
      }
    },
    // 提交订单
    onSubmit(formName, method) {
      this.saveBtnLoading = true
      if (this.activeName === 'newTab') {
        this.$refs['newTabForm'].validate((valid) => {
          if (valid) {
            const formData = this.handleForm(this.orderForm)
            this.$service
              .saveNewOrder(formData, '保存成功')
              .then((res) => {
                this.saveBtnLoading = false
                if (method === 'save') {
                  this.$emit('go-back')
                } else if (method === 'batch') {
                  this.$router.push({
                    name: 'batchOrder',
                    params: {
                      orderId: res.orderId
                    }
                  })
                } else if (method === 'cSave') {
                  let orderForm = {
                    orderId: res.orderId,
                    orderNo: res.orderNo,
                    orderName: res.orderName,
                    partnerId: res.partnerId,
                    buyType: res.buyType,
                    sellingType: res.sellingType,
                    iesSwitch: res.iesSwitch,
                    contractBeginDate: res.contractBeginDate,
                    contractEndDate: res.contractEndDate
                  }
                  this.$emit('next', orderForm)
                }
              })
              .catch((e) => {
                this.saveBtnLoading = false
              })
          } else {
            this.saveBtnLoading = false
            return false
          }
        })
      }
    },
    handleForm(data) {
      let formData = JSON.parse(JSON.stringify(data))
      formData.totalContract = (formData.sellingType === 1 && formData.totalContract) ? formData.totalContract : 0
      const orderTag = this.handleOrderTag(data.orderTag)
      formData.orderTag = orderTag.join(',')
      // 转换CPM -> PV
      if (this.contractUnit === 'CPM') {
        formData.totalContract = formData.totalContract * 1000
      }
      return formData
    },
    handleOrderTag(val) {
      let tags = []
      val.forEach((item) => {
        // 全选了一级
        if (item.children) {
          // 需要把所有的子级拿出来,放到tags里面
          tags = tags.concat(
            item.children.map((e) => {
              return e.value.split('-')[1]
            })
          )
        } else {
          tags.push(item.value.split('-')[1])
        }
      })
      return tags
    },
    handleCheckRequiredTag() {
      const allRequiredTagsList = this.tagList.filter((item) => item.isRequired === 1)
      if (allRequiredTagsList.length === 0) {
        return { status: true }
      } else {
        let isSelectd = []
        this.orderForm.orderTag.forEach((item) => {
          if (item.children) {
            isSelectd = isSelectd.concat(item.value)
          } else {
            isSelectd.push(parseInt(item.value.split('-')[0]))
          }
        })
        const isRequiredNotSelect = []
        allRequiredTagsList.forEach((item) => {
          if (isSelectd.indexOf(item.value) === -1) {
            isRequiredNotSelect.push(item.label)
          }
        })
        if (isRequiredNotSelect.length === 0) {
          return { status: true }
        } else {
          return {
            status: false,
            message: '请选择' + isRequiredNotSelect.join()
          }
        }
      }
    },
    validateTagRule() {
      const singleCheckedTags = this.tagList.filter(item => item.validationRule === 1)
      const checkedTagsMap = new Map()
      this.orderForm.orderTag.forEach(item => {
        if (typeof item.value === 'string' && item.value.indexOf('-') > 0) {
          const typeId = parseInt(item.value.split('-')[0])
          checkedTagsMap.has(typeId) ? checkedTagsMap.set(typeId, checkedTagsMap.get(typeId) + 1) : checkedTagsMap.set(typeId, 1)
        } else {
          checkedTagsMap.set(item.value, (item.children ? item.children.length : 0))
        }
      })
      const invalidTagTypes = []
      checkedTagsMap.forEach((value, key, map) => {
        const curTag = singleCheckedTags.find(tag => tag.value === key)
        if (curTag && value > 1) {
          invalidTagTypes.push(curTag.label)
        }
      })
      if (invalidTagTypes.length > 0) {
        return `标签 ${invalidTagTypes.join('、')} 为单选项`
      }
    },
    getAvailableCustomer() {
      this.options = []
      this.$service.getAvailableCustomer().then((data) => {
        this.options = JSON.parse(JSON.stringify(data || [])).map((item) => {
          return {
            value: item.partnerId,
            label: item.partnerName
          }
        })
      })
    },
    // 获取单个订单数据
    getOrderInfo(val) {
      this.$service.getOrderById({ id: val }).then((data) => {
        this.orderForm.orderId = data.orderId
        this.orderForm.orderNo = data.orderNo
        this.orderForm.orderName = data.orderName
        this.orderForm.partnerId = data.partnerId
        this.orderForm.partnerName = data.partnerName
        this.orderForm.partnerName = data.adDspPartner.partnerName
        this.orderForm.buyType = data.buyType
        this.orderForm.sellingType = data.sellingType
        this.orderForm.totalContractType = data.totalContractType
        this.orderForm.totalContract = data.totalContract
        this.orderForm.adSalesmanList = data.adSalesmanList
        this.orderForm.description = data.description
        this.orderForm.ipFilter = data.ipFilter
        this.orderForm.iesSwitch = data.iesSwitch
        this.orderForm.contractBeginDate = data.contractBeginDate
        this.orderForm.contractEndDate = data.contractEndDate
        this.orderForm.orderTag = data.orderTag !== '' ? data.orderTag.split(',') : []
        this.orderForm.customerBrands = data.customerBrands || []
        this.orderForm.customerProducts = data.customerProducts || []
        if (data.orderTag) {
          let tagsMap = JSON.parse(JSON.stringify(this.tagList)).reduce(
            (result, item) => {
              result[item.value] = item
              result[item.value].children = []
              return result
            },
            {}
          )
          this.tagList.forEach((item) => {
            item.children.forEach((e) => {
              data.orderTag.split(',').forEach((value) => {
                if (value === e.value.split('-')[1]) {
                  tagsMap[item.value].children.push(e.label)
                }
              })
            })
          })
          this.tagsMapList = Object.keys(tagsMap).reduce((result, key) => {
            if (tagsMap[key].children.length > 0) {
              result.push(tagsMap[key])
            }
            return result
          }, [])
        }
        switch (this.orderForm.sellingType) {
          case 1:
            this.sellingTypeText = 'CPM'
            break
          case 2:
            this.sellingTypeText = 'CPC'
            break
          case 3:
            this.sellingTypeText = 'CPD'
        }
      })
    },
    // 获取业务员数据
    initSales(partnerId) {
      this.$service.getSalesmanList({ partnerId: partnerId }).then((res) => {
        if (Array.isArray(res || [])) {
          this.salesmanList = res || []
        } else {
          this.salesmanList = []
        }
      })
    },
    // 获取订单标签
    getOrderTags() {
      this.$service.getOrderTags().then((data) => {
        this.tagList = data.map((item) => {
          return {
            label: item.mediaTagTypeName,
            value: item.mediaTagTypeId,
            isRequired: item.isRequired,
            validationRule: item.validationRule,
            children: item.mediaTagsList.map((e) => {
              return {
                label: e.mediaTagName,
                value: item.mediaTagTypeId + '-' + e.mediaTagId // 子级value需要拼接
              }
            })
          }
        })
      })
    },
    // 获取售卖价格
    getSellTypes() {
      this.$service.queryDictData({ type: 'selling_type' }).then((res) => {
        this.sellOptions = (res || []).map((item) => {
          return {
            label: item.label,
            value: item.value * 1
          }
        })
      })
    },
    nextStep() {
      let orderForm = {
        orderId: this.orderForm.orderId,
        orderNo: this.orderForm.orderNo,
        orderName: this.orderForm.orderName,
        partnerId: this.orderForm.partnerId,
        buyType: this.orderForm.buyType,
        sellingType: this.orderForm.sellingType,
        iesSwitch: this.orderForm.iesSwitch,
        contractBeginDate: new Date(this.$moment(this.orderForm.contractBeginDate).format('YYYY-MM-DD 00:00:00')).getTime(),
        contractEndDate: new Date(this.$moment(this.orderForm.contractEndDate).format('YYYY-MM-DD 23:59:59')).getTime()
      }
      this.$emit('next', orderForm)
    },
    totalContractTypeChange() {
      this.orderForm.totalContract = undefined
      this.$refs.newTabForm.validateField('totalContract')
    }
  },
  created() {
    if (this.isShowParent) {
      this.getAvailableCustomer()
    } else {
      this.initSales(this.partnerId)
    }
    this.oldForm = this.handleForm(JSON.parse(JSON.stringify(this.orderForm)))
    this.getOrderTags()
    this.getSellTypes()
  }
}
</script>
<style lang="stylus" scoped>
.content-box-tab
  background-color #fff
  margin-bottom 16px
  border-radius 2px
.form-tabs
  >>>.el-tabs__header
    margin 0
    border-bottom 1px solid #f0f2f5
    padding 0 24px
  >>>.el-tabs__item
    font-size 16px
    height 55px
    line-height 55px
  >>>.el-tabs__content
    padding 16px 24px
>>>.el-tabs__nav-wrap::after
  display none
.el-select
  display block
.demo-ruleForm
  >>>.el-form-item
    max-width 800px
.cc-demo-ruleForm-info
  border-top 1px solid #f2f2f2
  padding-top 16px
  >>>.el-form-item
    margin-bottom 16px
.el-radio-button__inner
  width 98px
>>>.el-input-group__prepend, >>>.el-input-group__append
  background-color #fff
  color #606266
.input-select-append >>>.el-input__inner
  width 80px
.flex-form-item >>> .el-form-item__content
  display flex
  .el-radio-group
    flex-shrink 0
    margin-right 20px
</style>
